<template>
  <el-dialog
    :title="$t('navbar.viewSOP')"
    :visible.sync="isShow"
    center
    width="60%"
    class="sop_dialog"
  >
    <el-table
      :data="tableData" border
      style="width: 100%;border-radius: 0 !important"
      :header-cell-style="{ background: '#f7f7f9' }"
      max-height="300"
    >
      <el-table-column
        :label="$t('navbar.documentName')" prop="documentName" align="center"
        min-width="120"
      />
      <el-table-column
        :label="$t('basicData.fileName')" prop="fileName" align="center"
        min-width="120"
      />
      <el-table-column
        :label="$t('basicData.LatestVersion')" prop="currentVersionName" align="center"
        min-width="120"
      />
      <el-table-column
        :label="$t('GlobalSetObj.Updater')" prop="updateUserName" align="center"
        min-width="120"
      />
      <el-table-column
        :label="$t('GlobalSetObj.UpdateTime')" prop="updateTime" align="center"
        min-width="120"
      />
      <!-- 操作 -->
      <el-table-column :label="$t('collectionCenter.operation')" align="center" width="235">
        <template slot-scope="scope">
          <el-button
            size="small" round type="primary"
            @click="preView(scope.row)"
          >{{ $t('operationCenter.Preview') }}</el-button>
          <el-button
            size="small" round type="primary"
            @click="download(scope.row)"
          >{{ $t('GlobalSetObj.Download') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { getUserName } from '@/utils/asyncTools';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { sopMenuPage, sopViewDownload, documentDetail } from '@/api/sop';

export default {
  name: 'SearchMenu',
  data() {
    return {
      isShow: false,
      tableData: []
    };
  },
  methods: {
    openWin(val) {
      sopMenuPage(val).then(res => {
        console.log('res', res.data);
        if (res.code === 200) {
          this.getData(res.data.id);
        } else {
          this.isShow = true;
          this.tableData = [];
        }
      }).catch(() => {
        this.tableData = [];
      });
    },
    getData(value) {
      documentDetail(value).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.map(item => {
            const updateUserName = getUserName(item.updateUser, getUserIdAndNameObj());
            item.updateUserName = updateUserName;
            return item;
          });
          this.isShow = true;
        }
      });
    },
    preView(row) {
      if (!row.fileName) {
        this.$message.warning(this.$t('navbar.fileNotExist'));
        return;
      }
      // 调用接口（累计次数）
      const rowForm = {
        documentId: row.documentId,
        versionNo: row.currentVersion,
        accessType: 'PREVIEW'
      };
      sopViewDownload(rowForm).then(res => {
        if (res.code === 200 && res.data.fileUrl) {
          const ext = (row.fileName || '').substring(row.fileName.lastIndexOf('.') + 1).toLowerCase();
          const officeTypes = ['doc', 'docx', 'xls', 'xlsx', 'pptx'];
          const imgTypes = ['png', 'jpg', 'jpeg'];

          if (officeTypes.includes(ext)) {
            // Office文件使用在线预览
            const encodedUrl = encodeURIComponent(res.data.fileUrl);
            window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}`, '_blank');
          } else if (imgTypes.includes(ext)) {
            // 图片直接打开
            const win = window.open('', '_blank');
            win.document.write(`
              <html>
                <head>
                  <title>图片预览</title>
                  <style>
                    body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; background: #f5f5f5; }
                    img { max-width: 95%; max-height: 95%; object-fit: contain; }
                  </style>
                </head>
                <body>
                  <img src="${res.data.fileUrl}" />
                </body>
              </html>
            `);
            win.document.close();
          } else if (['pdf', 'PDF'].includes(ext)) {
            fetch(res.data.fileUrl)
              .then(response => response.blob())
              .then(blob => {
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
                setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
              })
              .catch(() => {
                // 降级方案：直接打开原链接
                window.open(res.data.fileUrl, '_blank');
              });
          } else {
            // 其余文件下载
            window.open(res.data.fileUrl, '_blank');
          }
        }
      });
    },
    download(row) {
      if (!row.fileName) {
        this.$message.warning(this.$t('navbar.fileNotExist'));
        return;
      }
      // 调用接口（累计次数）
      const rowForm = {
        documentId: row.documentId,
        versionNo: row.currentVersion,
        accessType: 'DOWNLOAD'
      };
      sopViewDownload(rowForm).then(res => {
        if (res.code === 200 && res.data.fileUrl) {
          const link = document.createElement('a');
          link.href = res.data.fileUrl;
          link.download = row.fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sop_dialog ::v-deep .el-dialog--center {
  text-align: left !important;
}
.sop_dialog ::v-deep .el-dialog__title {
  font-weight: 700;
  font-size: 17px;
}
.sop_dialog ::v-deep .el-table__header .el-table__cell .cell {
  font-weight: bold;
  font-size: 15px;
  color: #000;
}
</style>
